import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-service-agreement-pdf',
  templateUrl: './service-agreement-pdf.component.html',
  styleUrl: './service-agreement-pdf.component.scss',
  standalone: false
})
export class ServiceAgreementPdfComponent {
 @Input() CompanyName: string = '';
}
